import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { Input } from "antd";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { green } from "../constants/colors";
import logo from "../assets/images/msm-motors-white-logo.png";
import logoBlack from "../assets/images/msm-motors-black-logo.png";
import CustomSearch from "./customSearch";
import Header from "../container/carDetails/header";
import MainSearch from "./mainSearch";
const pages = ["Newly Listed car", "Lowest Mileage", "Offer"];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

function CustomHeader({ brand, landing }) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const { Search } = Input;
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        borderBottom: "1px solid hsla(0, 0%, 100%, .15)",
        padding: "5px 0",
        display: { xs: "none", md: "flex" },
      }}
      position="static"
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  // sx={{ color: landing ? "white" : "black" }}
                  key={page}
                  onClick={handleCloseNavMenu}
                >
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <img
            className="w-[80px] h-[50px] md:w-[90px] md:h-[60px] hidden md:flex"
            src={landing === "true" ? logo : logoBlack}
            alt="logo"
          />
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{
                  my: 2,
                  mx: 2,
                  color: landing ? "white" : "black",
                  display: "block",
                  textTransform: "capitalize",
                  ":hover": {
                    color: green,
                    background: "none",
                  },
                }}
              >
                {page}
              </Button>
            ))}
          </Box>

          {/* <MainSearch /> */}
          <Box
            sx={{
              flexGrow: 0,
              display: {
                xs: "none",
                md: "flex",
                color: landing ? "white" : "black",
              },
            }}
          >
            <Typography className="flex items-center gap-2" component="div">
              <PhoneInTalkIcon />
              <Typography
                sx={{ borderLeft: "1px solid gray", paddingLeft: "8px" }}
                component="div"
              >
                <Typography variant="p" component="div">
                  To More Inquiry
                </Typography>
                <Typography variant="p" component="div">
                  +92-637 627 723
                </Typography>
              </Typography>
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default CustomHeader;
